// extracted by mini-css-extract-plugin
module.exports = {"container":"OverlayInfoSign_container__32LlK"};